export default __webpack_public_path__ + "static/media/error-outline-icon--orange.01a43e68.svg";